module.exports = __webpack_public_path__ + "img/youtubFooter.d1fda338.svg";